/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_PriorityInputs */

const cs_form_priority = /** @type {(inputs: Form_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorita`)
};

const en_form_priority = /** @type {(inputs: Form_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Form_PriorityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_priority = /** @type {((inputs?: Form_PriorityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_PriorityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_priority(inputs)
	return cs_form_priority(inputs)
});